<template>
  <form-layout :label="label">
    <router-button class="btn-dark" :text="text" :to="to"/>
  </form-layout>
</template>
  
<script>
import FormLayout from '@/views/templates/FormLayout';
import RouterButton from '@/views/molecules/buttons/RouterButton';
import {RouteLocationRaw} from 'vue-router';

export default {
  name: "DetailDocumentItem",
  components: {
    FormLayout,
    RouterButton,
  },
  props: {
    label: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true,
    },
    to: {
      type: RouteLocationRaw,
      required: true,
    },
  },
}
</script>
